import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { Number22v9c06q24q04 as Number_0 } from './Number.mjs';
import { toStringImpl1e40cnb3vvknd as toStringImpl } from './js/internal/boxedLong/boxedLong.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from './Comparable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.MIN_VALUE_1 = -9223372036854775808n;
        this.MAX_VALUE_1 = 9223372036854775807n;
        this.SIZE_BYTES_1 = 8;
        this.SIZE_BITS_1 = 64;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var LongClass;
function Long() {
  if (LongClass === VOID) {
    class $ extends Number_0() {
      toString() {
        return toStringImpl(this, 10);
      }
    }
    initMetadataForClass($, 'Long', VOID, VOID, [Comparable()]);
    LongClass = $;
  }
  return LongClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instancel8ig9z4updma,
};
//endregion

//# sourceMappingURL=Primitives.mjs.map
